<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>
<script>
  import store from './store/'
  export default {
    name: 'app'
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    height: 100%;
  }

  .main {
    background: #ededed;
  }
</style>



// WEBPACK FOOTER //
// App.vue?38ef6ec1